import { InternalChatGroupFormCreateType } from 'components/internal-chat/InternalChatGroupFormCreate';

export const createInternalChatGroupInitialValues: Partial<InternalChatGroupFormCreateType> = {};
